import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData,
    PromoPanelGameConfiguration
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {ASBonusPickOptions, WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {HorribleHeroesGameMode} from "./HorribleHeroesGameMode";
import {IHorribleHeroesGameData} from "./server/data/IHorribleHeroesServerData";
import {HorribleHeroesGameModuleConfig} from "./HorribleHeroesGameModuleConfig";
import {HorribleHeroesGameAssets} from "./HorribleHeroesGameAssets";
import {HorribleHeroesSoundConfig} from "./HorribleHeroesSoundConfig";
import {SoundManager} from "./resource/sound/SoundManager";

export class HorribleHeroesPromoPanelConfig implements PromoPanelGameConfiguration {
    constructor() {
    }

    public getActionSpinOptions(): ActionSpinOptions {
        return {
            hasActionSpin: true,
            gameName: "Infectious5",
            bonusGame: {
                header: () => "BONUS",
                options: [{
                    name: "TOXIC HAZARD",
                    id: 1,
                    image: "Toxic_Logo.png"
                }, {
                    name: "LOCK N' LOAD",
                    id: 2,
                    image: "lock_Logo.png"
                }],
                type: ASBonusPickOptions.PICK_MODE,
                pickNeededForModes: [HorribleHeroesGameMode.FREESPIN_PICK],
                pickNeededForBuyFeatures: ["FREESPIN_3_SCATTERS","FREESPIN_4_SCATTERS","FREESPIN_5_SCATTERS"]
            },
            graphics: {
                backgroundTextureName: HorribleHeroesGameAssets.MAIN_GAME_BACKGROUND //Loaded in intro view config.
            },
            getParsedData: (response: IHorribleHeroesGameData, bet: number, prevResponse: IHorribleHeroesGameData): ASWinData => {
                const parsedData: ASWinData = {
                    totalWin: Number(response.accumulatedRoundWin),
                    wasFeatureBuy: response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin: this.freespinTriggeredThisSpin(response),
                    totalSpinWinnings: Number(response.totalSpinWinnings),
                    isBigWin: this.isBigWin(response),
                    winType: WINTYPE.NORMAL,
                    featureName: this.getFeatureName(response),
                    isRoundComplete: this.isRoundComplete(response),
                    isBonusEnd: this.isBonusEnd(response),
                    isWinCapHit: false,

                }
                return parsedData;
            }
        };
    }

    public onActionSpinPlaySound(trigger: ActionSpinSound): void {
        if (trigger == ActionSpinSound.WIN) {
            SoundManager.playSound(HorribleHeroesSoundConfig.AS_WIN);
        } else if (trigger == ActionSpinSound.BIG_WIN) {
            SoundManager.playSound(HorribleHeroesSoundConfig.AS_WIN_BIG);
        }
    }

    private freespinTriggeredThisSpin(response: IHorribleHeroesGameData): boolean {
        return response.mode === HorribleHeroesGameMode.NORMAL && response.nextMode === HorribleHeroesGameMode.FREESPIN_PICK;
    }

    private isBigWin(response: IHorribleHeroesGameData): boolean {
        let win: number = Number(response.mode === HorribleHeroesGameMode.NORMAL ? response.accumulatedRoundWin : response.totalSpinWinnings);

        if (response.wasFeatureBuy) {
            const betPrice: number = HorribleHeroesGameModuleConfig.featurePrice.getBuyFeaturePriceAS(response);
            let winRatio: number = Helper.ceilToDecimals((win / betPrice), 2);
            return winRatio >= 1;
        }

        let winRatio: number = Helper.ceilToDecimals((win / Number(response.playedBetValue)), 2);
        return winRatio >= 15;
    }

    private getFeatureName(response: IHorribleHeroesGameData): string {
        if (response.superFSActivated || response.superFSTriggered) {
            if (response.playerFSSelection === 1) {
                return "INFECTIOUS SPINS MAYHEM: TOXIC HAZARD"
            } else if (response.playerFSSelection === 2) {
                return "INFECTIOUS SPINS MAYHEM: LOCK N' LOAD"
            } else {
                return "INFECTIOUS SPINS MAYHEM"
            }

        } else {
            if ((response.mode === HorribleHeroesGameMode.NORMAL && response.nextMode !== HorribleHeroesGameMode.NORMAL) || (response.mode === HorribleHeroesGameMode.FREESPIN_PICK)) {
                return "Pick Bonus Mode"
            } else if (response.mode !== HorribleHeroesGameMode.NORMAL) {
                if (response.playerFSSelection === 1) {
                    return "INFECTIOUS SPINS: TOXIC HAZARD"
                } else if (response.playerFSSelection === 2) {
                    return "INFECTIOUS SPINS: LOCK N' LOAD"
                } else {
                    return ""
                }
            } else {
                return response.mode
            }
        }
    }

    private isRoundComplete(response: IHorribleHeroesGameData): boolean {
        return true;
    }

    private isBonusEnd(response: IHorribleHeroesGameData): boolean {
        return response.nextMode === HorribleHeroesGameMode.NORMAL && (response.mode === HorribleHeroesGameMode.FREESPIN_LOW || response.mode === HorribleHeroesGameMode.FREESPIN_MID);
    }


}